import { createSignal } from '@react-rxjs/utils'
import { filter } from 'rxjs'

export interface AdsEventConversion {
  event: 'conversion'
  currency: string
  transaction_id: string
  value: number
  send_to: string
}

export type AdsEvent = AdsEventConversion

export const [adsEventChange$, setAdsEvent] = createSignal<AdsEvent>()

const conversionEvent$ = adsEventChange$.pipe(
  filter((adsEvent): adsEvent is AdsEventConversion => adsEvent.event === 'conversion'),
)

const mergedAdsEvent$ = conversionEvent$

// create immediate subscription to observable
if (typeof window !== 'undefined') {
  mergedAdsEvent$.subscribe(({ event, ...payload }) => {
    if (!window.gtag) {
      console.log(`Ads event [${event}]:`, JSON.stringify(payload))
      return
    }
    window.gtag('event', event, payload)
  })
}
